import React from 'react';
import useStyles from './styles';

const LineBar = () => {
  const classes = useStyles();
  return <div className={classes.layout} />;
};

export default LineBar;
